<template>
  <div>
    <v-organisation-banner
      v-if="organisationStatistics"
      :organisation="organisation"
      :commercials-count="totalObjects"
      :reviews-count="organisationStatistics.created_by_reviews_count"
    />

    <div class="mb-3" v-if="relatedOrganisations && relatedOrganisations.length > 0">
      <div class="d-none d-md-block card card-body">
        <v-organisation-carousel
          :title="$t('sentence.media_agency_related_organisations', {orgName: organisation.name})"
          :organisations="relatedOrganisations"
          :per-page="6"
        />
      </div>
      <div class="d-block d-md-none card card-body">
        <v-organisation-carousel
          :title="$t('sentence.media_agency_related_organisations', {orgName: organisation.name})"
          :organisations="relatedOrganisations"
          :per-page="1"
        />
      </div>
    </div>

    <v-commercial-researches-block
      icon="play-circle"
      :title="$t('sentence.created_commercials', {orgName: organisation.name})"
      :translate-title="false"
      :researches="objectList"
      v-if="objectList.length > 0"
      :columns="3"
      :load-more="!!nextPageUrl"
      @load-more="getObjects(nextPageUrl, true)"
    />
  </div>
</template>


<script>
import CommercialResearchesBlock from '@/reviewer/components/CommercialResearchesBlock.vue';
import OrganisationBanner from '@/reviewer/components/OrganisationBanner.vue';
import OrganisationCarousel from '@/common/components/carousels/OrganisationCarousel.vue';
import { GenericListMixin } from '@/common/utils/mixins';
import { pageNotFound } from '@/common/utils/notify';
import { fetchOrganisationStatistics, fetchRelatedOrganisations } from '@/public/api';

export default {
  name: 'OrganisationViewMediaAgency',
  components: {
    'v-commercial-researches-block': CommercialResearchesBlock,
    'v-organisation-banner': OrganisationBanner,
    'v-organisation-carousel': OrganisationCarousel,
  },
  props: {
    organisation: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      apiPath: 'rev/researches/',
      organisationStatistics: null,
      relatedOrganisations: null,
    };
  },
  mixins: [
    GenericListMixin,
  ],
  computed: {
    isVisible() {
      return this.organisation.has_paid_license;
    },
  },
  methods: {
    getParams() {
      return { created_by: this.$route.params.slug };
    },
    async fetchOrganisationStatistics() {
      const response = await fetchOrganisationStatistics(this.organisation.slug);
      if (response.status === 200) {
        this.organisationStatistics = response.data;
      }
    },
    async fetchRelatedOrganisations() {
      const response = await fetchRelatedOrganisations(this.organisation.slug);
      if (response.status === 200) {
        this.relatedOrganisations = response.data;
      }
    },
  },
  created() {
    if (!this.isVisible) {
      pageNotFound();
      this.$router.push({ name: 'dashboard' });
    }
    this.fetchOrganisationStatistics();
    this.fetchRelatedOrganisations();
  },
};
</script>
